#import "../../../../common/components/Modules/TransactionEdit/graphql/InvoiceFragment.graphql"

mutation InvoiceSigningUpdate($input: InvoiceSigningUpdateInput!) {
  invoiceSigningUpdate(input: $input) {
    invoice {
        ...InvoiceFragment
    }
  }
}
